import Animation from '../class/Animation';

/**
 * アニメーションに関する処理
 * @depenndency Animation.js
 */
const animation = () => {
  const elements = document.querySelectorAll('[data-animation]') || [];
  if ( !elements.length ) return;
  elements.forEach((element) => {
    const animation = new Animation(element as HTMLElement);
    animation.init();
  });

  addEventListener('load', () => {
    const animated = document.querySelectorAll('.is-animate') || [];
    animated.forEach((element) => {
      element.classList.remove('is-animate');
    });
  })
}

export default animation;
